export default {
  // Semânticas
  info: 'Informação',
  success: 'Sucesso',
  warning: 'Aviso',
  danger: 'Perigo',
  critical: 'Crítico',
  error: 'Erro',
  muted: 'Mudo',
  value: 'Valor',
  premium: 'Premium',

  // Qualidade / natureza de problema
  bug: 'Bug',
  improvement: 'Melhoria',

  // Risco / governança
  risk: 'Risco',
  dependency: 'Dependência',
  impediment: 'Impedimento',
  issue: 'Problema',
  decision: 'Decisão',
  action: 'Ação',

  // Fluxo / status de trabalho
  backlog: 'Backlog',
  'to-do': 'A Fazer',
  'in-progress': 'Em Progresso',
  waiting: 'Aguardando',
  blocked: 'Bloqueado',
  review: 'Revisão',
  done: 'Concluído',
  'on-hold': 'Em Pausa',
  canceled: 'Cancelado',

  // ROAM
  resolved: 'Resolvido',
  owned: 'Assumido',
  accepted: 'Aceito',
  mitigated: 'Mitigado',

  // Status administrativo
  active: 'Ativo',
  inactive: 'Inativo',
  pending: 'Pendente',
  suspended: 'Suspenso',

  // Ambientes / ciclo de entrega
  planned: 'Planejado',
  development: 'Desenvolvimento',
  staging: 'Homologação',
  production: 'Produção'
}
